import {
  AppointmentsSyncSettings,
  ContactsSyncSettings,
  EmailsSyncSettings,
  TasksSyncSettings,
} from './sync-settings';
import { OutlookSyncProblemCode } from './sync-status';

export enum OutlookSyncTokenType {
  RefreshToken = 'refresh-token',
  PersonalAccessToken = 'personal-access-token',
}

interface MicrosoftAuthConfiguration {
  tokenType?: string | null;
  scopes?: string[] | null;
  refreshToken?: string | null;
  expiresIn?: string | null;
}

interface MaximizerAuthConfiguration {
  tokenType: string;
  personalAccessToken?: string | null;
  expiresIn?: string | null;
}

export interface UserSyncConfiguration {
  id: string;
  maximizerUserUid?: string;
  maximizerUserEmail?: string;
  microsoftUserId?: string;
  microsoftUserEmail?: string;
  tenantAlias?: string;
  workspaceId?: string;
  createdAt?: string;
  updatedAt?: string;
  lastTimeSynced?: string | null;
  lockedForSync?: boolean;
  needsManualIntervention?: boolean;
  enabled: boolean;
  contactsSync: ContactsSyncSettings;
  tasksSync: TasksSyncSettings;
  appointmentsSync: AppointmentsSyncSettings;
  emailsSync: EmailsSyncSettings;
  latestSyncProblemCode?: OutlookSyncProblemCode | null;
}

export interface CreateSyncConfigurationRequest {
  maximizerUserUid?: string;
  maximizerUserEmail?: string;
  microsoftUserId?: string;
  microsoftUserEmail?: string;
  tenantAlias?: string;
  tenantId?: string;
  workspaceId?: string;
  contactsSync?: Partial<ContactsSyncSettings>;
  tasksSync?: Partial<TasksSyncSettings>;
  appointmentsSync?: Partial<AppointmentsSyncSettings>;
  emailsSync?: Partial<EmailsSyncSettings>;
  microsoftAuth?: MicrosoftAuthConfiguration;
  maximizerAuth?: MaximizerAuthConfiguration;
}

export interface UpdateSyncConfiguration
  extends Partial<CreateSyncConfigurationRequest> {
  maximizerUserUid: string;
}

export interface FavoriteList {
  key: string | null;
  name: string | null;
}
